import React, { FC } from 'react';

import ButtonSocial from '~/components/button-social/ButtonSocial';
import { IButtonSocialGroup } from '~/interfaces/components/ButtonSocialGroup';

export interface IButtonSocialGroupProps extends IButtonSocialGroup {
  className?: string;
}

const ButtonSocialGroup: FC<IButtonSocialGroupProps> = ({
  socialButtons,
  socialNavAriaLabel,
  className,
}) => {
  const customClass = className ? ` ${className}` : '';

  if (!socialButtons || socialButtons.length === 0) {
    return null;
  }

  return (
    <nav
      className={`button-social-group${customClass}`}
      aria-labelledby={`button-social-group-${customClass}`}
    >
      <div id={`button-social-group-${customClass}`} style={{ display: 'none' }}>
        {socialNavAriaLabel || 'Social Links Navigation'}
      </div>
      {socialButtons.map((icon) => (
        <ButtonSocial
          iconName={icon.iconName}
          href={icon.href}
          key={icon.href}
          sideText={icon.sideText}
          target={icon.target}
          rel={icon.rel}
          border={icon.border}
          label={icon.label}
        />
      ))}
    </nav>
  );
};

export default ButtonSocialGroup;
